const getTotal = (statistics, status) => {
  return statistics.reduce((acc, item) => {
    if (item.status === status) {
      return item.total
    }

    return acc
  }, 0)
}

export default {
  afterPrepareShow () {
    this.absent = getTotal(this.statistics, 'absent')
    this.scheduled = getTotal(this.statistics, 'scheduled')
    this.canceled = getTotal(this.statistics, 'canceled')
    this.attended = getTotal(this.statistics, 'attended')
    this.total = this.statistics.reduce((acc, item) => {
      return acc + item.total
    }, 0)
  },
  getTotalAgendasActives () {
    this.$http.get('v1/professional/agendas/agendas/total_actives')
      .then(({data}) => {
        this.agendas = data.total
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/team/dashboard/gadget/components/statistics/resources/methods.js